<cs-header>
  <cs-header-title>{{ LL.changelog.title() }}</cs-header-title>
</cs-header>

<cs-content>
  <cs-card-list>
    @for (section of sections; track trackBySection($index, section)) {
      <cs-card class="changelog-card">
        @if (section.title) {
          <cs-card-title>
            {{ section.title }}
            @if (section.comingSoon) {
              <cs-badge [label]="LL.changelog.comingSoon()" color="purple" title-action></cs-badge>
            } @else if (section.date) {
              <cs-note title-action>{{ formatDate(section.date) }}</cs-note>
            }
          </cs-card-title>
        }
        <cs-card-content>
          <cs-markdown [textMarkdown]="section.content"></cs-markdown>
        </cs-card-content>
      </cs-card>
    }
  </cs-card-list>

  @if (canLoadMore) {
    <div class="loading-sentinel" #bottomSentinel>
      <cs-spinner size="small"></cs-spinner>
    </div>
  }
</cs-content>